import {
  collection,
  doc,
  onSnapshot,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { firestore } from "../firebase";
import { subscribeSharedFirestore } from "./sharedFirestoreSubscription";
import { normalizeStaff } from "../utils/staffValidation";

const usersCollection = collection(firestore, "users");

export function subscribeToStaff(onData, onError) {
  const handleRows = (rawRows) => {
    const rows = rawRows.map((item) => ({
      ...item,
      ...normalizeStaff(item),
    }));
    rows.sort((a, b) => (a.name || a.email || '').localeCompare(b.name || b.email || ''));
    onData(rows);
  };

  return subscribeSharedFirestore({
    key: "users:all",
    onData: handleRows,
    onError,
    start: (emit, emitError) => onSnapshot(
      usersCollection,
      (snapshot) => emit(snapshot.docs.map((item) => ({ id: item.id, ...item.data() }))),
      emitError
    ),
  });
}

export async function createStaffProfile(staff) {
  const value = normalizeStaff(staff);
  const ref = doc(firestore, "users", value.uid);

  await setDoc(ref, {
    name: value.name,
    username: value.name,
    email: value.email,
    mobile: value.mobile,
    role: value.role,
    joiningDate: value.joiningDate,
    leavingDate: value.leavingDate,
    status: value.status,
    isActive: value.status === "active",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export async function updateStaffProfile(staffId, staff) {
  const value = normalizeStaff(staff);
  const ref = doc(firestore, "users", staffId);

  await updateDoc(ref, {
    name: value.name,
    username: value.name,
    email: value.email,
    mobile: value.mobile,
    role: value.role,
    joiningDate: value.joiningDate,
    leavingDate: value.leavingDate,
    status: value.status,
    isActive: value.status === "active",
    updatedAt: serverTimestamp(),
  });
}

export async function setStaffActiveStatus(staffId, isActive, leavingDate = "") {
  const ref = doc(firestore, "users", staffId);
  await updateDoc(ref, {
    status: isActive ? "active" : "inactive",
    isActive,
    leavingDate: isActive ? "" : leavingDate,
    updatedAt: serverTimestamp(),
  });
}

export async function setCommunicationCentreAccess(staffId, enabled) {
  const ref = doc(firestore, "users", staffId);
  await updateDoc(ref, {
    communicationCentreEnabled: Boolean(enabled),
    updatedAt: serverTimestamp(),
  });
}
